import { useState } from "react";
import { Link,useNavigate} from "react-router-dom";
import MainContent from "../../../layouts/maincontent/MainContent";
import InputElement from "../../../shared/form/InputElement";
import ValidateResetPassword from "../../../validations/ValidateResetPassword";
import styleSetPassword from "./SetPassword.module.css";
import { editPassowrd } from "../../../adapters/apis/auth/auth";

function SetPassword() {
  const password_object = {
    old_password: "",
    password: "",
    confirm_password: "",
  };
  const [new_password, SetNewPassword] = useState({ ...password_object });
  const [passwordError, setPasswordError] = useState({ ...password_object });
  const [success, setSuccess] = useState(false);
  const navigate=useNavigate();
  const isNewPwdTooLong = (new_password.password || "").length > 10;

  function handleChange(parentCompenent, compenent, key, value) {
    SetNewPassword((prev) => ({
      ...prev,
      [key]: value,
    }));
  }
  function setError(key, value) {
    setPasswordError((prev) => ({
      ...prev,
      [key]: value,
    }));
  }
  function changePassword() {
    if (ValidateResetPassword(setError, new_password)) {
      editPassowrd({
        current_password: new_password["old_password"],
        password: new_password["password"],
        password_confirm: new_password["confirm_password"],
      })
        .then((res) => {
          setSuccess(true);
          SetNewPassword(password_object);

          setTimeout(()=>{
            navigate("/profile");
          },2000);
        })
        .catch((error) => {
          setSuccess(false);
          if (error?.response?.data?.errors?.current_password) {
            setError(
              "old_password",
              error.response.data.errors.current_password[0]
            );
          }

          if (error?.response?.data?.errors?.password) {
            setError("password", error.response.data.errors.password[0]);
          }

          if (error?.response?.data?.errors?.password_confirm) {
            setError(
              "confirm_password",
              error.response.data.errors.password_confirm[0]
            );
          }
        });
    }
  }

  return (
    <>
      <MainContent>
        <section
          className={`${styleSetPassword["section-content"]} section-content`}
        >
          <div className={`${styleSetPassword.container} container pt-5`}>
            <div className={`${styleSetPassword["card-box"]} card-box`}>
              {success && (
                <div className="alert alert-primary" role="alert">
                  تم تغيير كلمة المرور بنجاح.
                </div>
              )}
              <div className={`${styleSetPassword["box-content"]} box-content`}>
                <div className={`${styleSetPassword.box} box`}>
                  <h4
                    className={`${styleSetPassword["box-title"]} box-title mb-4`}
                  >
                    تعيين كلمة المرور
                  </h4>
                  <div className="row">
                    <div className="col-md-4">
                      <InputElement
                        mb4="mb-4 parent-password"
                        labelHtmlFor="old_password"
                        labelClassName={` required ${styleSetPassword["form-label"]} form-label`}
                        labelText="كلمة المرور الحالية"
                        inputType="password"
                        name="old_password"
                        inputClassName={`${styleSetPassword["form-control"]} form-control`}
                        inputID="old_password"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={passwordError.old_password}
                        value={new_password.old_password}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputElement
                        mb4="mb-4 parent-password"
                        labelHtmlFor="password"
                        labelClassName={` required ${styleSetPassword["form-label"]} form-label`}
                        labelText="كلمة المرور الجديدة"
                        inputType="password"
                        name="password"
                        inputClassName={`${styleSetPassword["form-control"]} form-control`}
                        inputID="new_password"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={passwordError.password}
                        value={new_password.password}
                        onChange={handleChange}
                        allowedPattern={/^[^\s]+$/}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputElement
                        mb4="mb-4 parent-password"
                        labelHtmlFor="confirm_password"
                        labelClassName={` required ${styleSetPassword["form-label"]} form-label`}
                        labelText="تأكيد كلمة المرور الجديدة"
                        inputType="password"
                        name="confirm_password"
                        inputClassName={`${styleSetPassword["form-control"]} form-control`}
                        inputID="confirm_password"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={passwordError.confirm_password}
                        value={new_password.confirm_password}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="btn-myProfile d-flex justify-content-start flex-md-row flex-column gap-lg-5 gap-3  align-items-center mt-4">
                    <button
                      onClick={changePassword}
                      id="change_password_save"
                      className={styleSetPassword["btn-edit"]}
                    >
                      حفظ  
                    </button>
                    <Link
                      to="/profile"
                      className={styleSetPassword["btn-cancle"]}
                    >
                      إلغاء
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </MainContent>
    </>
  );
}

export default SetPassword;
